import BashVersioned from "./bash-versioned.mdx";
import BashVersionless from "./bash-versionless.mdx";

{props.usesVersionlessApi ? (
  <BashVersionless {...props} />
 ) : (
  <BashVersioned {...props} />
 )}
